'use client';

import type { FC } from 'react';

import { ScrollTopButton } from '@packages/modules/src/ScrollTopButton/ScrollTopButton';
import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';

import { filterSettingsFab } from '../../activeFeatureFlags';
import { getTestId } from '../../utils/featureFlags/getTestId';

/**
 * Scroll to top button for search pages (MBA, SERP and ZeroResultsPage)
 * */
export const SearchScrollTopButton: FC = () => {
  const { setOutcome } = useAbTesting();

  const onAfterClick = () => {
    // remove if A/B test is finished
    setOutcome(getTestId(filterSettingsFab), {
      SCROLL: 1,
    });
  };

  return (
    <div className="z-app-bar fixed right-[2%] bottom-4">
      <ScrollTopButton onAfterClick={onAfterClick} />
    </div>
  );
};
